(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ask-a-question"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-dialog-target]');
    if (trigger) {
      const dialog = document.getElementById(trigger.getAttribute('data-dialog-target'));
      dialog?.showModal();
      return;
    }
    const closeBtn = event.target.closest('[data-dialog-close]');
    if (closeBtn) {
      const dialog = document.getElementById(closeBtn.getAttribute('data-dialog-close'));
      dialog?.close();
      return;
    }
    if (event.target.tagName === 'DIALOG' && event.target.classList.contains('ask-a-question__dialog')) {
      event.target.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ct-category-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ct-category-carousel')) {
    customElements.define(
      'ct-category-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.arrows = Array.from(this.querySelectorAll('.ct-cat__arrow'));
          if (!this.track) return;
          this.onClick = (e) => {
            const btn = e.currentTarget;
            const card = this.track.querySelector('.ct-cat__item');
            const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap || '0') : 300;
            const visible = Math.max(1, Math.floor(this.track.clientWidth / step));
            this.track.scrollBy({ left: Number(btn.dataset.dir) * step * visible, behavior: 'smooth' });
          };
          this.update = () => {
            const max = this.track.scrollWidth - this.track.clientWidth - 2;
            if (this.arrows[0]) this.arrows[0].disabled = this.track.scrollLeft <= 2;
            if (this.arrows[1]) this.arrows[1].disabled = this.track.scrollLeft >= max;
          };
          this.arrows.forEach((a) => a.addEventListener('click', this.onClick));
          this.track.addEventListener('scroll', this.update, { passive: true });
          window.addEventListener('resize', this.update);
          this.update();
        }
        disconnectedCallback() {
          this.arrows?.forEach((a) => a.removeEventListener('click', this.onClick));
          this.track?.removeEventListener('scroll', this.update);
          window.removeEventListener('resize', this.update);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
